export default "__VITE_ASSET__Dke$G3fH__"